import { Injectable, EventEmitter } from '@angular/core'
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router'
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { Resposta } from '../services/app.response';
import { MEAT_API } from '../services/app.api';
import { ChamadaModel } from '../models/chamada.model';
import { ClienteModel } from '../app.login.model';
import { ContasReceberModel } from '../models/contas-receber.model';
import { ClienteElevadorModel } from '../models/cliente.elevadores.model';
import { CodigoAtendimentoModel } from '../models/codigo-atendimento.model';

@Injectable()
export class DashboardService {

    constructor(private http: HttpClient,
       public firestore: AngularFirestore,
        public fireAuth: AngularFireAuth) {

    }

    Buscar(cliente: ClienteModel){
       return this.http.post<Resposta<ChamadaModel[]>>(`${MEAT_API}/v1/usuario/listarChamados`, cliente);
    }

    GerarRelatorio(data: ChamadaModel){
        return this.http.post<Resposta<ChamadaModel>>(`${MEAT_API}/v1/usuario/gerarRelatorio`, data);
    }

    BuscarNotaFiscal(data: ContasReceberModel){
        return this.http.post<Resposta<ContasReceberModel[]>>(`${MEAT_API}/v1/usuario/listarNotaFiscal`, data);
    }

    ListarElevador(codigo:number){
        return this.http.get<Resposta<ClienteElevadorModel[]>>(`${MEAT_API}/v1/usuario/listarElevador/${codigo}`);
    }

    BuscarCodigoAtendimento(){
        return this.http.get<Resposta<CodigoAtendimentoModel[]>>(`${MEAT_API}/v1/usuario/buscarCodigoAtendimento`);
    }

    // ImprimirICMS(data: ContasReceberModel){
    //      return this.http.post<Resposta<ContasReceberModel>>(`${MEAT_API}/v1/usuario/imprimirICMS`, data);
    // }

    GerarRelatorioNotaFiscal(data: ContasReceberModel){
         return this.http.post<Resposta<ContasReceberModel>>(`${MEAT_API}/v1/empresa/gerarRelatorio`, data);
    }

    BuscarBoletoBancario(data: ContasReceberModel){
        return this.http.post<Resposta<ContasReceberModel[]>>(`${MEAT_API}/v1/usuario/listarBoletoBancario`, data);
    }

     imprimirBoleto(data: ContasReceberModel){
         return this.http.post<Resposta<ContasReceberModel>>(`${MEAT_API}/v1/usuario/imprimirBoleto`, data);
      }

    logout() {
        localStorage.removeItem('usuarioLogado');
    }
}
